import React__default from 'react';
import styled from 'styled-components';
import { useIsMobile, TaktIdProvider, createStormTaktId, Flex, withTaktFallbackId, Heading } from '@amzn/storm-ui';
import { H as HMHConsistentIngressAnchor } from './HMHConsistentIngressAnchor/HMHConsistentIngressAnchor-CKgoIGCs.js';
import { F as FocusPageHeaderWrapper, a as FocusTitle, b as FocusCloseButton } from './FocusPageHeader.styles-DygDK2r5.js';
import { A as ActionsContainer } from './actions/ActionsContainer-S7YG1kA7.js';
import { g as getTranslationComponent } from '../i18n/PageHeaderTranslation/index-D-JlEl92.js';
import { H as HelpDropdown } from './HelpDropdown/HelpDropdown-CmdRZdpI.js';
import { A as AttributesContainer } from './attributes/AttributesContainer-Ct1akiB4.js';
import { u as useHelpInfo } from '../utils/useHelpInfo-DSBDDgvL.js';
import { u as useHMHScriptLoaded } from '../utils/useHasHMHScriptLoaded-CEqYoUYv.js';
import { I as IntlProvider } from '../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DUNZ897o-Dn-1_05J.js';

const VerticalDivider = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1j0y84m-0"
})(["width:1px;height:90%;align-self:center;border-inline-start:", ";margin-inline:", ";"], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.xxsmall.default);
const CloseButton = withTaktFallbackId(FocusCloseButton);
const FocusPageHeader = ({
  applicationName,
  onClose,
  title,
  renderPageTitleIcon,
  renderAttributes,
  renderActions,
  attributesErrorMessage,
  actionsErrorMessage,
  taktId,
  taktValue,
  locale = 'en-US',
  ...props
}) => {
  const isMobile = useIsMobile();
  const helpInfo = useHelpInfo();
  // Determine whether the HelpMeHereAPI script has loaded
  const hasHMHScriptLoaded = useHMHScriptLoaded();
  return /*#__PURE__*/React__default.createElement(IntlProvider, {
    resetKey: locale,
    translations: getTranslationComponent(locale)
  }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('focus-page-header')
  }, /*#__PURE__*/React__default.createElement(FocusPageHeaderWrapper, props, /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center",
    alignSelf: "start"
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    size: "base",
    onClick: onClose,
    taktFallbackId: createStormTaktId('focus-page-header-close-button'),
    "data-testid": "focus-page-header-close-button"
  }), title && /*#__PURE__*/React__default.createElement(FocusTitle, {
    alignItems: "center"
  }, typeof title === 'string' ? /*#__PURE__*/React__default.createElement(Heading, {
    renderAs: "h1",
    size: "small",
    "data-testid": "focus-page-header-title"
  }, title) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title)), renderPageTitleIcon === null || renderPageTitleIcon === void 0 ? void 0 : renderPageTitleIcon(), title && !!renderAttributes && /*#__PURE__*/React__default.createElement(VerticalDivider, null), !isMobile && !!renderAttributes && /*#__PURE__*/React__default.createElement(AttributesContainer, {
    errorMessage: attributesErrorMessage
  }, renderAttributes())), /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center"
  }, !isMobile && (!!renderActions || hasHMHScriptLoaded) && /*#__PURE__*/React__default.createElement(ActionsContainer, {
    errorMessage: actionsErrorMessage
  }, renderActions === null || renderActions === void 0 ? void 0 : renderActions(), hasHMHScriptLoaded && /*#__PURE__*/React__default.createElement(HMHConsistentIngressAnchor, {
    applicationName: applicationName
  })), isMobile && !!helpInfo && /*#__PURE__*/React__default.createElement(HelpDropdown, {
    helpInfo: helpInfo
  })))));
};

export { FocusPageHeader as F };
//# sourceMappingURL=FocusPageHeader-CapKftgt.js.map
